import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=99a3a5ae&"
import script from "./AddCategory.vue?vue&type=script&lang=js&"
export * from "./AddCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports